import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Dashboard, DashboardRoute, CreateUpdateDashboardModel } from '../../domain/models/dashboard';
import { DashboardDomainService } from '../../domain/services/dashboard/dashboard.domain.service';
import { Job } from '../../domain/models/job';
import { JobStatus } from '../../domain/enums/jobStatus';
import { JobDomainService } from '../../domain/services/job/job.domain.service';
import * as _ from 'lodash';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Injectable()
export class DashboardOverviewService {
    private baseUrl: string;

    constructor(
        private dashboardDomainService: DashboardDomainService,
        private jobDomainService: JobDomainService) { }

    getAllDashboards(): Observable<Dashboard[] | {}> {
        return this.dashboardDomainService.getAllDashboards();
    }

    getActiveRoutes(): Observable<Array<DashboardRoute[]> | {}> {
        return forkJoin(this.getActiveNonProjectRoutes(), this.getActiveProjectRoutes());
    }

    getActiveNonProjectRoutes(): Observable<DashboardRoute[] | {}> {
        return this.jobDomainService.getAllJobs()
            .map((jobs: Job[]) => {
                let filteredJobs = _.filter(jobs, (job: Job) => {
                    return job.status === JobStatus.Created || job.status === JobStatus.Scheduled;
                });
                let routes = filteredJobs.map((job: Job) => new DashboardRoute(job));
                return routes;
            });
    }

    getActiveProjectRoutes(): Observable<DashboardRoute[] | {}> {
        return this.jobDomainService.getAllJobsInProjects()
            .map((jobs: Job[]) => {
                let filteredJobs = _.filter(jobs, (job: Job) => {
                    return job.status === JobStatus.Created || job.status === JobStatus.Scheduled;
                });
                let routes = filteredJobs.map((job: Job) => new DashboardRoute(job));
                return routes;
            });
    }

    createDashboard(dashboard: CreateUpdateDashboardModel): Observable<string> {
        return this.dashboardDomainService.createDashboard(dashboard);
    }

    updateDashboard(dashboard: CreateUpdateDashboardModel): Observable<any> {
        return this.dashboardDomainService.updateDashboard(dashboard);
    }

    deleteDashboard(dashboardId: string): Observable<any> {
        return this.dashboardDomainService.deleteDashboard(dashboardId);
    }

    deleteDashboardLogo(dashboardId: string): Observable<any> {
        return this.dashboardDomainService.deleteDashboardLogo(dashboardId);
    }

    getBaseUrl(dashboardId: string): string {
        return this.baseUrl;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard-overview/services/dashboard-overview.service.ts